//import 'bootstrap';
$(document).ready(() => {
  const hamb = document.querySelector("#hamb");
  const mainNav = document.querySelector("#main-nav");
  const overlay = document.querySelector("#overlay");
  const closeMenuBtn = document.querySelector("#close-menu");
  const searchBtn = document.querySelector("#search-btn");
  const searchBtnMobile = document.querySelector("#search-btn-mobile");
  const closeSearchBtn = document.querySelector("#close-search-btn");
  const searchModal = document.querySelector("#search-modal");

  const hdrWrapper = document.querySelector(".header-wrapper");
  const hdr = document.querySelector(".header-wrapper .inner");
  const mainDiv = document.querySelector("main");
  let lastScroll = window?.pageYOffset || 0;

  // floating labels for gform inputs with top label
  $(
    "form .top_label .gfield .ginput_container input, form .top_label .gfield .ginput_container textarea",
  ).on("focus", function () {
    $(this).parent().parent(".gfield").addClass("active");
  });

  $(
    "form .top_label .gfield .ginput_container input, form .top_label .gfield .ginput_container textarea",
  ).on("blur", function () {
    if ($(this).val().length == 0) {
      $(this).parent().parent(".gfield").removeClass("active");
    }
  });

  hamb.addEventListener(
    "click",
    function (e) {
      e.stopPropagation();
      openMenu();
    },
    false,
  );

  closeMenuBtn.addEventListener(
    "click",
    function (e) {
      e.stopPropagation();
      closeMenu();
    },
    false,
  );

  searchBtn.addEventListener(
    "click",
    function (e) {
      e.stopPropagation();
      openSearch();
    },
    false,
  );

  searchBtnMobile.addEventListener(
    "click",
    function (e) {
      e.stopPropagation();
      openSearch();
    },
    false,
  );

  closeSearchBtn.addEventListener(
    "click",
    function (e) {
      e.stopPropagation();
      closeSearch();
    },
    false,
  );

  // opens the search
  function openSearch() {
    searchModal.classList.remove("hidden");
  }

  // closes the search
  function closeSearch() {
    searchModal.classList.add("hidden");
  }

  // opens main nav
  function openMenu() {
    mainNav.classList.remove("translate-x-full");
    mainNav.classList.remove("right-[-20px]");
    overlay.classList.remove("hidden");
    mainNav.classList.add("right-0");
    $(hamb).hide();
    $(closeMenuBtn).show();
    $("body").addClass("overflow-hidden");
  }

  // closes main nav
  function closeMenu() {
    mainNav.classList.add("translate-x-full");
    overlay.classList.add("hidden");
    $(closeMenuBtn).hide();
    $(hamb).show();
    $("body").removeClass("overflow-hidden");
  }

  // animate on scroll library
  AOS.init({ once: true });

  var dropdowns = document.querySelectorAll(".dropdown");
  var viewportWidth = $(window).width();

  setHeaderScrollHeight();

  $("body").on("click", function () {
    // closeSearch();
    closeAllDropDowns();
  });

  $(window).scroll(function () {
    // hide/unhide header on scroll down/ scroll up and add shadow to header
    handleHeaderEffect();

    if (viewportWidth <= 1023) {
      return;
    } else {
      closeSearch();
      closeAllDropDowns();
    }
  });

  // $('#searchHolderDesktop button').click(function (e) {
  //     e.stopPropagation()
  //     openSearch();
  // });

  // $('#searchHolderDesktop form').click(function (e) {
  //     e.stopPropagation()
  //     //openSearch();
  // });

  // function openSearch() {
  //     $('#searchHolderDesktop').addClass('active')
  //     $('#searchHolderDesktop form input.search-field').focus()
  //     $('.topnav a, .topnav .pipe').each(function () {
  //         $(this).addClass('hidden')
  //     })
  // }

  // function closeSearch() {
  //     $('#searchHolderDesktop').removeClass('active');
  //     $('#searchHolderDesktop form input.search-field').blur()
  //     $('.topnav a, .topnav .pipe').each(function () {
  //         $(this).removeClass('hidden')
  //     })
  // }

  function closeAllDropDowns() {
    $("header").removeClass("active");
    $(".underlay").removeClass("active");

    $(dropdowns).each(function () {
      $(this).removeClass("open");

      const caret = $(".caret", this).first();

      if (caret.hasClass("rotate-up")) {
        caret.removeClass("rotate-up").addClass("rotate-down");
      }
    });
  }

  // on resize, reset this wiewport width

  if (viewportWidth <= 1023) {
    preventScrollOnClick();
    setHeaderScrollHeight();
    setWpAdminBarOnMobile();

    $(".navbar .menu-item.menu-item-has-children").on("click", function (e) {
      e.stopPropagation();
      // e.preventDefault();

      const isHeaderActive = $("header").hasClass("active");
      const isSubmenuActive = $(this).hasClass("active");

      if (isHeaderActive) {
        closeAllDropDowns();
      } else if (
        (!isHeaderActive && isSubmenuActive) ||
        (isHeaderActive && !isSubmenuActive) ||
        !isSubmenuActive
      ) {
        $("header").addClass("active");
        $(".underlay").addClass("active");
        $(this).addClass("open");
      } else {
        $("header").removeClass("active");
        $(".underlay").removeClass("active");
        $(this).removeClass("open");
      }

      showSubmenu(this);
    });
  } else {
    preventScrollOnClick();
    setHeaderScrollHeight();

    $("header div.menu-item:not(.dropdown)").mouseenter(function () {
      closeAllDropDowns();
    });

    $(".navbar .menu-item.menu-item-has-children").on("click", function (e) {
      e.stopPropagation();
      closeAllDropDowns();
      $("header").addClass("active");
      $(".underlay").addClass("active");
      $(this).addClass("open");

      animateCaret(this);
      showSubmenu(this);
    });
  }

  function setHeaderScrollHeight() {
    const headerHeight = $(hdr).height();

    mainDiv.style.marginTop = `${headerHeight}px`;
  }

  function setWpAdminBarOnMobile() {
    $("#wpadminbar").css("position", "fixed");
  }

  function handleHeaderEffect() {
    let scrolly = window.pageYOffset;

    if (scrolly > 100) {
      hdr.classList.add("shadow-md", "bg-white");
      if (window.pageYOffset > lastScroll) {
        hdr.classList.add("-translate-y-full");
        $(hdrWrapper).addClass("top-0");
      } else {
        hdr.classList.remove("-translate-y-full");
        $(hdrWrapper).removeClass("top-0");
      }
    } else {
      hdr.classList.remove("-translate-y-full", "shadow-md", "bg-white");
      $(hdrWrapper).removeClass("top-0");
      setHeaderScrollHeight();
    }
    lastScroll = scrolly;
  }

  function preventScrollOnClick() {
    $("#main-main-nav .menu-item-has-children a:not(.dropdown-item)").on(
      "click",
      function (e) {
        e.preventDefault();
      },
    );
  }

  function animateCaret(el) {
    const caret = $(el).find(".caret").first();

    if (caret.hasClass("rotate-down")) {
      caret.removeClass("rotate-down");
    }
    caret.addClass("rotate-up");
  }

  function showSubmenu(el) {
    const submenu = $(".menu-item-has-children", el);

    submenu
      .on("mouseover", function () {
        $(".dropdown-menu.has-children").show();
      })
      .on("mouseout", function () {
        $(".dropdown-menu.has-children").hide();
      });
  }

  // File Upload Button
  const labelText = $(".inf_fileupload label").text();
  $('.inf_fileupload input[type="file"').wrap(
    '<label class="file_wrapper"></label>',
  );
  $(".file_wrapper").prepend("<span>" + labelText + "</span>");
});
